import React from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenNib,
  faLaptopCode,
  faMagnifyingGlass,
  faRocket,
  faShareNodes,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: "ui-ux-design",
      icon: faPenNib,
      title: "UX Strategy & Website Design",
      desc:
        "Customer-focused journeys and interfaces that improve clarity, trust, and conversion.",
    },
    {
      id: "web-development",
      icon: faLaptopCode,
      title: "Web Development",
      desc:
        "Fast, scalable websites engineered for reliability, maintainability, and measurable performance.",
    },
    {
      id: "search-engine-optimization",
      icon: faMagnifyingGlass,
      title: "SEO & Organic Growth",
      desc:
        "Technical SEO plus content strategy designed to grow qualified organic traffic.",
    },
    {
      id: "social-media-marketing",
      icon: faShareNodes,
      title: "Social Content & Growth",
      desc:
        "Content systems that improve brand recall, engagement quality, and inbound opportunities.",
    },
    {
      id: "search-engine-marketing",
      icon: faRocket,
      title: "Performance Ads & Lead Gen",
      desc:
        "Paid campaigns focused on lead quality, CAC/CPL control, and conversion outcomes.",
    },
    {
      id: "local-business-growth",
      icon: faLocationDot,
      title: "Local SEO & Visibility",
      desc:
        "Map and local search optimization so nearby buyers find and trust your business.",
    },
  ];

  return (
    <section className="about-services" aria-label="Our services">
      <div className="about-services-wrap">
        <header className="about-services-head">
          <span className="about-services-kicker">What we do</span>
          <h2>Services built for scalable growth</h2>
          <p>
            From positioning to execution, we help you improve visibility,
            conversion, and retention with one coordinated team.
          </p>
        </header>

        <div className="about-services-list">
          {services.map((s) => (
            <article
              key={s.id}
              className="about-services-item"
              onClick={() => navigate(`/services/${s.id}`)}
              tabIndex={0}
              role="button"
            >
              <div className="about-services-icon">
                <FontAwesomeIcon icon={s.icon} />
              </div>

              <div className="about-services-content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
